import type { CityConfig } from "@/pages/city-template/types";

export const fishkillConfig: CityConfig = {
  city: "Fishkill",
  state: "New York",
  stateAbbr: "NY",
  slug: "fishkill",
  route: "/cities/fishkill",
  title: "Emergency & Expedited Passport Fishkill NY | Same Day Passport",
  metaDescription:
    "Emergency passport Fishkill NY — same day, 24-hour, and 3-5 day expedited passport processing for Dutchess County. Fast Passport Center serves Fishkill, Beacon, Poughkeepsie, Newburgh, and all Hudson River Valley communities.",
  h1: "Emergency & Expedited Passport Services in Fishkill, NY",
  heroSubtitle:
    "Fishkill's fast passport solution — from the I-84 corridor to the Hudson River Valley. Whether you're flying out of Stewart International or Albany, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Modern%20Fishkill%20New%20York%20shopping%20and%20business%20district%20along%20Main%20Street%20with%20the%20Hudson%20Valley%20landscape%2C%20Route%209%20corridor%2C%20suburban%20Dutchess%20County%20community%20with%20rolling%20hills%20and%20greenery%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20scenic%20New%20York%20state%20scene%20with%20beautiful%20suburban%20development%20and%20natural%20surroundings&width=1600&height=700&seq=ny-fishkill-hero-001&orientation=landscape",
  heroImageAlt: "Modern Fishkill New York along the Route 9 corridor with Hudson Valley landscape and suburban development",
  geoPosition: "41.5356; -73.8990",
  geoPlacename: "Fishkill, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~65 miles (South in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Fishkill", zips: "12524" },
    { name: "Beacon", zips: "12508" },
    { name: "Poughkeepsie", zips: "12601, 12602, 12603, 12604" },
    { name: "Newburgh", zips: "12550, 12551, 12552, 12555" },
    { name: "Wappingers Falls", zips: "12590" },
    { name: "Hopewell Junction", zips: "12533" },
    { name: "Highland", zips: "12528" },
    { name: "New Paltz", zips: "12561" },
    { name: "Kingston", zips: "12401, 12402" },
    { name: "Middletown", zips: "10940, 10941" },
    { name: "Middletown", zips: "10940, 10941" },
    { name: "Cornwall", zips: "12518, 12520" },
    { name: "Montgomery", zips: "12549" },
    { name: "Walden", zips: "12586" },
    { name: "Cold Spring", zips: "10516" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230, 12231, 12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Fishkill travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Fishkill residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Dutchess County Corridor",
      desc: "Fishkill, Beacon, Poughkeepsie, Newburgh, and all Dutchess County communities along the I-84 corridor — we serve the entire region.",
    },
  ],
  testimonials: [
    {
      name: "Michael D.",
      location: "Fishkill, NY",
      rating: 5,
      text: "Had a business trip to Germany in 5 days. Fast Passport Center got my expedited passport processed in 3 days. The service was excellent and professional.",
      service: "Expedited Passport",
    },
    {
      name: "Patricia W.",
      location: "Hopewell Junction, NY",
      rating: 5,
      text: "Renewed my expired passport through Fast Passport Center. Chose the 5-day option and had it back in 4. The whole process was smooth and stress-free.",
      service: "Passport Renewal",
    },
    {
      name: "Thomas H.",
      location: "Wappingers Falls, NY",
      rating: 5,
      text: "First-time passport for my family cruise. The agent helped us with the acceptance clerk appointment at the Fishkill post office. Processed in 5 days.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "fishkill-1",
      name: "Fishkill Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "1068 Main Street",
      city: "Fishkill",
      state: "NY",
      zip: "12524",
      phone: "845-896-9600",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Downtown Fishkill",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Fishkill passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "fishkill-2",
      name: "Beacon Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "369 Main Street",
      city: "Beacon",
      state: "NY",
      zip: "12508",
      phone: "845-831-4200",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Beacon (~5 miles)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Fishkill and Beacon residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "fishkill-3",
      name: "Wappingers Falls Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "38 Market Street",
      city: "Wappingers Falls",
      state: "NY",
      zip: "12590",
      phone: "845-297-4290",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Wappingers Falls (~8 miles)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Wappingers Falls, Fishkill, and Dutchess County communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Fishkill?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Fishkill residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Fishkill?",
      a: "The Fishkill Post Office at 1068 Main Street is the major Fishkill passport acceptance facility. The Beacon Post Office at 369 Main Street and Wappingers Falls Post Office at 38 Market Street are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Fishkill?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout Fishkill, Beacon, and Wappingers Falls. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Fishkill?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Fishkill passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Fishkill?",
      a: "The fastest way to renew a passport in Fishkill is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Fishkill?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Fishkill and all Dutchess County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Fishkill?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Fishkill. We serve the I-84 corridor and all of Dutchess County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Fishkill", address: "various CVS locations across Fishkill, Beacon, and Wappingers Falls", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Beacon", address: "various Walgreens locations throughout Beacon and Dutchess County", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Fishkill", address: "various UPS Store locations in Fishkill and Beacon", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Poughkeepsie", address: "various FedEx Office locations across Poughkeepsie", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart Photo Center — Fishkill", address: "various Walmart locations in Fishkill area", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Newburgh",
      address: "50 Liberty Street, Newburgh, NY 12550",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Newburgh DMV office for license renewals and REAL ID applications. Serves Fishkill, Beacon, and all Dutchess County communities.",
      featured: true,
    },
    {
      name: "NYS DMV — Poughkeepsie",
      address: "22a Ulster Avenue, Poughkeepsie, NY 12601",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Poughkeepsie DMV office serving north Dutchess County and Fishkill residents.",
      featured: false,
    },
    {
      name: "NYS DMV — Wappingers Falls",
      address: "2 Rinaldi Boulevard, Wappingers Falls, NY 12590",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Wappingers Falls DMV office serving east Dutchess County communities.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SWF",
      name: "Stewart International Airport",
      distance: "~15 miles from Fishkill",
      address: "1 1st Street, New Windsor, NY 12553",
      note: "Regional airport with flights to major U.S. hubs. Primary airport for Fishkill, Newburgh, and Dutchess County travelers.",
      flightUrl: "https://www.swfny.com/",
      flightLabel: "Stewart Airport",
      featured: true,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~80 miles from Fishkill",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Major upstate New York airport with flights to major U.S. cities. Alternative for Fishkill travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: false,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~65 miles from Fishkill",
      address: "Queens, NY 11430",
      note: "Major international airport with flights worldwide. Alternative for Fishkill travelers.",
      flightUrl: "https://www.jfk.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Fishkill travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Fishkill residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Fishkill residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Fishkill residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Fishkill, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Fishkill residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Fishkill travelers with immediate departure needs from Stewart International, Albany, or JFK." },
    { name: "Passport Renewal", description: "Fast passport renewal for Fishkill residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Fishkill residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Fishkill residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Fishkill and Dutchess County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Fishkill." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Fishkill travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Fishkill travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Fishkill team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Fishkill address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Staten Island", route: "/cities/staten-island" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "White Plains", route: "/cities/white-plains" },
    { name: "New Rochelle", route: "/cities/new-rochelle" },
    { name: "Mount Vernon", route: "/cities/mount-vernon" },
    { name: "Tarrytown", route: "/cities/tarrytown" },
    { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    { name: "Newburgh", route: "/cities/newburgh" },
    { name: "Kingston", route: "/cities/kingston" },
    { name: "Middletown", route: "/cities/middletown-ny" },
    { name: "New Paltz", route: "/cities/new-paltz" },
    { name: "Beacon", route: "/cities/beacon" },
    { name: "Binghamton", route: "/cities/binghamton" },
    { name: "Long Island", route: "/cities/long-island" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "Rhinebeck", route: "/cities/rhinebeck" },
    { name: "Hyde Park", route: "/cities/hyde-park" },
    { name: "Red Hook", route: "/cities/red-hook" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Fishkill and all of Dutchess County as a remote courier service. We do not have a physical office in Fishkill, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Fishkill area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Fishkill and all of Dutchess County. From the I-84 corridor to Beacon, Poughkeepsie to Newburgh — we serve the entire region with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Fishkill and all surrounding communities across Dutchess County. Whether you're in Beacon, Wappingers Falls, Hopewell Junction, or Cold Spring, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Fishkill customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Fishkill travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Fishkill travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Fishkill. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default fishkillConfig;